import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SERVER_API_URL} from 'src/app/app.constants';
import {ISubRuleMySuffix} from 'src/app/shared/model/subrule-my-suffix.model';


type EntityResponseType = HttpResponse<ISubRuleMySuffix>;
type EntityArrayResponseType = HttpResponse<ISubRuleMySuffix[]>;
 
@Injectable({ providedIn: 'root' })
export class SubRuleMySuffixService {
  

    constructor(private http: HttpClient) { }

    

    get(url:string){
        return this.http.get<any>(SERVER_API_URL+url, { observe: 'response' });
    }

    post(data:ISubRuleMySuffix){
        return this.http.post<any>(SERVER_API_URL+"api/sub-rule",data, { observe: 'response' });
    }

    delete(id:number){
        return this.http.delete<any>(SERVER_API_URL+"api/sub-rule/"+id, { observe: 'response' });
    }

    getSubRuleDataFromCertificateRequest(scopeRuleId,crId) {
        return this.http.get<any>(SERVER_API_URL+'api/get-sub-rule-from-certificate-request/'+scopeRuleId+'/'+crId, { observe: 'response' });
    }
}
